export default class SupportUtils {
  static _passiveListener = null;

  static get passiveListener() {
    if (SupportUtils._passiveListener != null) {
      return SupportUtils._passiveListener;
    }

    try {
      const config = Object.defineProperty({}, 'passive', {
        get() {
          SupportUtils._passiveListener = true;
          return true;
        },
      });

      window.addEventListener('testPassive', null, config);
      window.removeEventListener('testPassive', null);
    } catch (error) {
      SupportUtils._passiveListener = false;
    }

    return SupportUtils._passiveListener;
  }
}
